export const SET_RESERVATION_DATA = 'SET_RESERVATION_DATA';
export const SET_SINGLE_RESERVATION_DATA = 'SET_SINGLE_RESERVATION_DATA';
export const ADD_RESERVATION_DATA = 'ADD_RESERVATION_DATA';
export const DELETE_RESERVATION_DATA = 'DELETE_RESERVATION_DATA';
export const CALC_RESERVATION_CREDIT = 'CALC_RESERVATION_CREDIT';



// WEBPACK FOOTER //
// ./src/store/modules/reservation/action-types.js